export default {
  andUp: '& Up'
};



/** WEBPACK FOOTER **
 ** ./src/widgets/star-rating/defaultLabels.js
 **/